<app-public-header></app-public-header>

<div class="page auth-page">
  <div class="page-content">
    <div class="container">
      <div class="row main-row">
        <div class="col-12 col-md-8 col-lg-5 p-5 d-flex align-items-center justify-content-center left-col">
          <div class="col-content text-center">
            <h3 class="the-title">{{ 'errors.404.h1' | translate }}</h3>
            <p class="lead">{{ 'errors.404.lead' | translate }}</p>
            <img alt="{{ configService.ownerNicename }}" src="../../../../../assets/img/404.png">
            <p>{{ 'errors.404.text' | translate }}</p>
            <button mat-raised-button color="primary" routerLink="../..">
              <mat-icon fontSet="fal" fontIcon="fa-long-arrow-left"></mat-icon>
              {{ 'errors.404.goToHomeBtnText' | translate }}
            </button>
          </div> <!-- /.col-content -->
        </div> <!-- /.col -->
      </div> <!-- /.row -->
    </div> <!-- /.container -->
  </div> <!-- /.page-content -->
</div> <!-- /.page -->

<app-public-footer></app-public-footer>
